import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/lossFunds/pending.png'
import _imports_1 from '@/assets/lossFunds/success.png'
import _imports_2 from '@/assets/lossFunds/cancel.png'
import _imports_3 from '@/assets/themetwo/calander_lossRel.png'


const _hoisted_1 = { class: "dayImage" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_4 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_5 = { class: "main-date" }
const _hoisted_6 = {
  key: 0,
  class: "pending"
}
const _hoisted_7 = {
  key: 1,
  class: "completed"
}
const _hoisted_8 = {
  key: 2,
  class: "no-rewards"
}
const _hoisted_9 = { class: "dayTitle" }
const _hoisted_10 = { class: "dayTitle" }
const _hoisted_11 = { class: "dateText2" }
const _hoisted_12 = { class: "subText" }
const _hoisted_13 = {
  key: 0,
  class: "pending"
}
const _hoisted_14 = {
  key: 1,
  class: "completed"
}
const _hoisted_15 = {
  key: 2,
  class: "no-rewards"
}
const _hoisted_16 = { class: "dayCard" }
const _hoisted_17 = { class: "dayTitleIsShow" }

import { checkDate, dayFormat, formatCurrency, } from '@/utils/commonFunction';
import { getAmountSum } from '@/view/components/supportFunction';
import { PropType, } from 'vue';
import { ref, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'cashBackHistoryCard',
  props: {
    dayCount: {
        type: Number,
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    createTime: {
        type: String,
        default: () => ""
    },
    availableAmount: {
        type: Number,
        default: () => 0
    },
    title: {
        type: String,
        default: () => ""
    },
    totalAmount: {
        type: Number,
        default: () => 0
    },
    activityStatus: {
        type: Number
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    isShowDetails: {
        type: Boolean,
        default: () => true
    },
    givenAmount: {
        type: Number,
        default: () => 0
    },
},
  setup(__props) {

const props = __props

const getDayCardStyle = (date: string) => {
  const status = checkDate(date);

  if (status === 0 && props.istodayClaimed) {
    return {
      color: '#36d836',
      border: '1px solid #36d836',
      boxShadow: '0 0 6px #36d83680',
      borderRadius: '10px',
      padding: '4px'
    };
  }

  if (status < 0) {
    return {
      color: 'gray',
      border: '1px solid #666',
      borderRadius: '10px',
      padding: '4px'
    };
  }

  if (status > 0) {
    return {
      color: '#fff',
      border: '1px solid #fff',
      borderRadius: '10px',
      padding: '4px'
    };
  }

  return {};
};

const isCollapsed = ref(true); 

const toggleCollapse = () => {
    isCollapsed.value = !isCollapsed.value;
};

const statusColor = computed(() => {
  if (props.activityStatus === 1) return '#36d836';
  if (props.activityStatus === 2 || props.activityStatus === 3) return '#e2675f';
  if (props.activityStatus === 0) return '#2196f3';
  return '';
});


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: "cardContainer",
    style: _normalizeStyle(__props.isShowDetails ? { 
        borderColor: __props.activityStatus == 1 ? '#36d8365e' : (__props.activityStatus == 2 || __props.activityStatus == 3) ? '#e2675f80' : __props.activityStatus == 0 ? '#2196f380' : 'transparent',
        boxShadow: __props.activityStatus == 1 
            ? '0 0 10px #36d83660' 
            : (__props.activityStatus == 2 || __props.activityStatus == 3) 
            ? '0 0 10px #ff000060' 
            : __props.activityStatus == 0 
            ? '0 0 10px #2196f360' 
            : 'none'
    } : { border: 'none', boxShadow: 'none' })
  }, [
    (__props.isShowDetails)
      ? (_openBlock(), _createBlock(_component_van_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "12",
              class: "dayImageColumn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (__props.activityStatus == 0)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                    : _createCommentVNode("", true),
                  (__props.activityStatus == 1)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                    : _createCommentVNode("", true),
                  (__props.activityStatus == 2 || __props.activityStatus == 3)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(__props.createTime?.split(' ')[0]), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "12",
              class: "statusColumn"
            }, {
              default: _withCtx(() => [
                (__props.dayList?.length <= 0 || !__props.dayList)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(__props.activityStatus == 0 ? 'pending' : __props.activityStatus == 1 ? 'completed' : 'no-rewards')
                    }, [
                      (props.activityStatus == 0 && (__props.dayList?.length <= 0 || !__props.dayList))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_van_icon, {
                              name: "clock-o",
                              class: "status-icon"
                            }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('activityStatus.pending')), 1)
                          ]))
                        : (props.activityStatus == 1 && (__props.dayList?.length <= 0 || !__props.dayList))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createVNode(_component_van_icon, {
                                name: "checked",
                                class: "status-icon"
                              }),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('activityStatus.completed')), 1)
                            ]))
                          : ((props.activityStatus == 2 || props.activityStatus == 3) && (__props.dayList?.length <= 0 || !__props.dayList))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(_component_van_icon, {
                                  name: "warn-o",
                                  class: "status-icon"
                                }),
                                _createElementVNode("span", null, _toDisplayString(props.activityStatus == 2 ? _ctx.$t('activityStatus.noRewards') : _ctx.$t('activity.overdue')), 1)
                              ]))
                            : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_van_row, { class: "totalRow" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "topRow",
                  style: {"margin":"10px 0"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(__props.title), 1),
                    _createElementVNode("div", {
                      class: "valueText",
                      style: _normalizeStyle({ color: statusColor.value })
                    }, _toDisplayString(_unref(formatCurrency)(__props.totalAmount)), 5)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "topRow",
                  style: {"margin":"10px 0"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('activity.cashBackTotal')), 1),
                    _createElementVNode("div", {
                      class: "valueText",
                      style: _normalizeStyle({ color: statusColor.value })
                    }, _toDisplayString(__props.dayList ? _unref(formatCurrency)(_unref(getAmountSum)(__props.dayList)) : _unref(formatCurrency)(0)), 5)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!__props.isShowDetails)
      ? (_openBlock(), _createBlock(_component_van_row, {
          key: 1,
          class: "historyCard"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "4",
              class: "dayColumn"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "dayImage2" }, [
                  _createElementVNode("img", {
                    src: _imports_3,
                    alt: ""
                  })
                ], -1)
              ])),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "7",
              class: "infoColumn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, _toDisplayString(__props.createTime?.split(' ')[0]), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('activity.givenAmount')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "4",
              class: "amountColumn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(formatCurrency)(__props.givenAmount)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "9",
              class: "statusColumn"
            }, {
              default: _withCtx(() => [
                (__props.dayList?.length <= 0 || !__props.dayList)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(__props.activityStatus == 0 ? 'pending' : __props.activityStatus == 1 ? 'completed' : 'no-rewards')
                    }, [
                      (props.activityStatus == 0 && (__props.dayList?.length <= 0 || !__props.dayList))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode(_component_van_icon, {
                              name: "clock-o",
                              class: "status-icon"
                            }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('activityStatus.pending')), 1)
                          ]))
                        : (props.activityStatus == 1 && (__props.dayList?.length <= 0 || !__props.dayList))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createVNode(_component_van_icon, {
                                name: "checked",
                                class: "status-icon"
                              }),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('activityStatus.completed')), 1)
                            ]))
                          : ((props.activityStatus == 2 || props.activityStatus == 3) && (__props.dayList?.length <= 0 || !__props.dayList))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createVNode(_component_van_icon, {
                                  name: "warn-o",
                                  class: "status-icon"
                                }),
                                _createElementVNode("span", null, _toDisplayString(props.activityStatus == 2 ? _ctx.$t('activityStatus.noRewards') : _ctx.$t('activity.overdue')), 1)
                              ]))
                            : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.isShowDetails && __props.dayList?.length > 0 || !__props.dayList)
      ? (_openBlock(), _createBlock(_component_van_row, {
          key: 2,
          justify: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "24",
              class: "collapse-header",
              onClick: toggleCollapse
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('activity.detalhamento')), 1),
                _createVNode(_component_van_icon, {
                  name: isCollapsed.value ? 'arrow-down' : 'arrow-up',
                  class: "arrow-icon"
                }, null, 8, ["name"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.isShowDetails && !isCollapsed.value)
      ? (_openBlock(), _createBlock(_component_van_row, {
          key: 3,
          style: {"margin-top":"10px","display":"flex","justify-content":"center","gap":"5px"},
          justify: "space-between"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dayList, (i, index) => {
              return (_openBlock(), _createBlock(_component_van_col, {
                span: "4",
                key: index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(dayFormat)(i.date, 0)), 1),
                    _createElementVNode("div", null, _toDisplayString(_unref(formatCurrency)(i.amount)), 1)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createTextVNode(_toDisplayString() + " ", 1),
            (__props.dayList?.length <= 0 || !__props.dayList)
              ? (_openBlock(), _createBlock(_component_van_col, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 4))
}
}

})